import React from "react";
import { useTranslation } from "react-i18next";
import { meetsContrastAA } from "../domain/presentation";

export type EmailBuilderContrastHintPreset =
  | "block-surface"
  | "content-background"
  | "button-fill";

interface IEmailBuilderColorContrastHintProps {
  color: string;
  contrastAgainst?: string;
  largeText?: boolean;
  preset?: EmailBuilderContrastHintPreset;
}

export function EmailBuilderColorContrastHint(
  props: IEmailBuilderColorContrastHintProps,
) {
  const {
    color,
    contrastAgainst,
    largeText = false,
    preset = "block-surface",
  } = props;
  const { t } = useTranslation();

  if (!contrastAgainst || meetsContrastAA(color, contrastAgainst, largeText)) {
    return null;
  }

  if (preset === "button-fill") {
    return (
      <p className="email-builder-settings-field-hint">
        {t("May not meet contrast requirements on the button fill.")}
      </p>
    );
  }

  const ratio = largeText ? "3:1" : "4.5:1";
  const messageKey =
    preset === "content-background"
      ? "May not meet {{ratio}} contrast on the content background."
      : "May not meet {{ratio}} contrast on this block background.";

  return (
    <p className="email-builder-settings-field-hint">
      {t(messageKey, { ratio })}
    </p>
  );
}
